import PBRShaderFragment from "./PBRMaterialShadeFrag.glsl"
import PBRVertexShader from "./PBRMaterialShadeVert.glsl"
import {
    UniformsUtils,
    UniformsLib,
    Vector2,
    Matrix3,
    Color,
    Vector4,
    Vector3,
    LogLuvEncoding,
    ShaderMaterial,
    Matrix4,
    FlatShading,
    Material,
    DoubleSide,
    AdditiveBlending
} from "three"
class PBRShaderMaterial extends ShaderMaterial {
    constructor(materialOptions) {
        super();
        this.isPBRShaderMaterial = true
        this.derivatives = true;
        this.materialType = "PBRShaderMaterial";
        this.uniforms = UniformsUtils.merge([
            UniformsLib.common,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            // UniformsLib.displacementmap,
            UniformsLib.roughnessmap,
            UniformsLib.metalnessmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                //各项异性
                uAnisotropyDirection: {
                    value: 1.0
                },
                uAnisotropyFactor: {
                    value: 1.0
                },

                lightMapIntensity: {
                    value: 1.0
                },
                translucencyMap: {
                    value: null
                },
                translucencyMapTransform: {
                    value: new Matrix3()
                },
                mapTransform: {
                    value: new Matrix3()
                },
                alphaMapTransform: {
                    value: new Matrix3()
                },
                emissiveMapTransform: {
                    value: new Matrix3()
                },
                roughnessMapTransform: {
                    value: new Matrix3()
                },
                metalnessMapTransform: {
                    value: new Matrix3()
                },
                aoMapTransform: {
                    value: new Matrix3()
                },
                normalMapTransform: {
                    value: new Matrix3()
                },
                bumpMapTransform: {
                    value: new Matrix3()
                },
                lightMapTransform: {
                    value: new Matrix3()
                },
                uOpacityAdditive: {
                    value: 0.0
                },
                uSubsurfaceTranslucencyThicknessFactor: {
                    value: 1.06
                },
                uSubsurfaceTranslucencyFactor: {
                    value: 1
                },

                uSubsurfaceTranslucencyColor: {
                    value: new Color(0x00ff00)
                },
                uClearCoatFactor: {
                    value: 0.5
                },
                uEmitMultiplicative: {
                    value: 0.0
                },
                uClearCoatRoughnessFactor: {
                    value: 1.0
                },
                uClearCoatIor: {
                    value: 1.0
                },
                uClearCoatTint: {
                    value: new Color(0xff0000)
                },
                uClearCoatThickness: {
                    value: 1.0
                },
                worldNormalMatrix: {
                    value: new Matrix3()
                },
                normalScale: {
                    value: new Vector2(1, 1) //用于缩放normalMap
                },
                bumpScale: {
                    value: 1
                },
                uEnvironmentTransform: {
                    value: new Matrix4()
                },
                emissiveIntensity: {
                    value: 1
                },
                uSpecularF0Factor: {
                    value: 0.5
                },
                uClearCoatF0: {
                    value: 1.0
                },
                uSpecularPeak: {
                    value: 0.0
                },
                uTextureEnvironmentSpecularPBRLodRange: {
                    value: new Vector2(0, 0)
                },
                // uTextureEnvironmentSpecularPBRTextureSize: {
                //     value: new Vector2(256, 256)
                // },
                uTextureEnvironmentSpecularPBRTextureSize: {
                    value: new Vector2(256, 256)
                },
                sIntegrateBRDF: {
                    value: null
                },
                uDiffuseSPH: {
                    value: null
                },
                uMultiplyLightMap: {
                    value: 0
                },
                emissive: {
                    value: new Color(0x000000)
                },
                roughness: {
                    value: 0.0
                },
                metalness: {
                    value: 0.0
                },
                uEnvironmentExposure: {
                    value: 1
                },
                envMapIntensity: {
                    value: 1
                }, // temporary
                uHalton: {
                    value: new Vector4(0, 0, 1, 8)
                },
                opacity: {
                    value: 1
                },
                uDrawOpaque: {
                    value: 0
                },
                uAOPBROccludeSpecular: {
                    value: 1
                },
                translucency_uv: {
                    value: 0
                },
                map_uv: {
                    value: 0
                },
                alphaMap_uv: {
                    value: 0
                },
                emissiveMap_uv: {
                    value: 0
                },
                roughnessMap_uv: {
                    value: 0
                },
                metalnessMap_uv: {
                    value: 0
                },
                aoMap_uv: {
                    value: 0
                },
                normalMap_uv: {
                    value: 0
                },
                bumpMap_uv: {
                    value: 0
                },
                lightMap_uv: {
                    value: 0
                },
                //反转法线
                uNormalMapFlipY: {
                    value: 0
                },
                uNormalMapFactor: {
                    value: 1
                },
               

            }
        ]);
        //是否使用tangent切线
        this.anisotropy=false;

        this.vertexTangents = false;
        this.vertexColors = 0;
        this.visible = true;
        this.userData = {};
        this.normalMapType = 0;
        this.useClearCoat = false;
        this.useSSS = false;
        this.transparent=false;
        this.vertexShader = PBRVertexShader;
        this.fragmentShader = PBRShaderFragment;
        this.lights = true;
        this.initUniformProperty();
        this.setValues(materialOptions);
        this.alphaTest=0.0;

        //UV坐标
        this.textureType = {
            map: 0,
            alphaMap: 1,
            metalnessMap: 2,
            emissiveMap: 3,
            roughnessMap: 4,
            aoMap: 5,
            normalMap: 6,
            bumpMap: 7,
            lightMap: 8,
            translucencyMap: 9
        }


    }
    initUniformProperty() {
        Object.defineProperty(this, "useSSS", {
            set: function (value) {
                if (value) {
                    this.defines["USE_SSS"] = "USE_SSS";
                } else {
                    delete this.defines["USE_SSS"];
                }


            },
            get: function () {
                return this.defines["USE_SSS"] == "USE_SSS";
            }
        })
        Object.defineProperty(this, "useClearCoat", {
            set: function (value) {
                if (value) {
                    this.defines["USE_CLEARCOAT"] = "USE_CLEARCOAT";
                } else {
                    delete this.defines["USE_CLEARCOAT"];
                }
                this.needsUpdate = true;

            },
            get: function () {
                return this.defines["USE_CLEARCOAT"] == "USE_CLEARCOAT";
            }
        })

        for (let key in this.uniforms) {
            Object.defineProperty(this, key, {
                set: function (value) {
                    if (key === "translucencyMap") {
                        if (value && value.isTexture) {
                            this.defines["USETRANSLUCENCYMAP"] = "USETRANSLUCENCYMAP";
                        } else {
                            delete this.defines["USETRANSLUCENCYMAP"];
                        }

                    }
                    this.uniforms[key].value = value;
                },
                get: function () {
                    return this.uniforms[key].value;
                }
            })
        }

    }

    setValues(values) {

        if (values === undefined) return;
        for (var key in values) {
            var newValue = values[key];
            console.log(key, newValue)
            if (newValue === undefined) {
                console.warn("THREE.Material: '" + key + "' parameter is undefined.");
                continue;

            }

            // for backward compatability if shading is set in the constructor
            if (key === 'shading') {

                console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                this.flatShading = (newValue === FlatShading) ? true : false;
                continue;

            }
            if (key == 'brdfTexyure') {
                this.uniforms.sIntegrateBRDF.value = materialOptions.brdfTexyure;
                this.uniforms.sIntegrateBRDF.value.encoding = materialOptions.encoding ? materialOptions.encoding : LogLuvEncoding;
                continue;

            }
            if (key == 'color') {
                this.uniforms['diffuse'].value.setRGB(newValue.r, newValue.g, newValue.b);
                continue;
            }

            var currentValue = this.uniforms[key];

            if (currentValue === undefined) {

                console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
                continue;

            }

            if (currentValue && currentValue.isColor) {

                currentValue.set(newValue);

            } else if ((currentValue && currentValue.isVector3) && (newValue && newValue.isVector3)) {

                currentValue.copy(newValue);

            } else if ((currentValue && currentValue.isVector2) && (newValue && newValue.isVector2)) {

                currentValue.copy(newValue);

            } else if ((newValue && newValue.isTexture)) {
                this.setTexture(key, newValue)

            } else {
                this.setUniformValue(key, newValue)
            }

        }
    }
    cloneUniforms(src) {

        var dst = {};

        for (var u in src) {

            dst[u] = {};

            for (var p in src[u]) {

                var property = src[u][p];

                if (property && (property.isColor ||
                        property.isMatrix3 || property.isMatrix4 ||
                        property.isVector2 || property.isVector3 || property.isVector4 ||
                        property.isTexture)) {

                    dst[u][p] = property.clone();


                } else if (Array.isArray(property)) {

                    dst[u][p] = property.slice();

                } else {

                    dst[u][p] = property;

                }

            }

        }

        return dst;

    }
    //
    clone() {
        return new this.constructor().copy(this);
    }

    copyAllPropertyMaterial(source) {
        Material.prototype.copy.call(this, source);
        this.isPBRShaderMaterial = true;
        this.materialType = "PBRShaderMaterial";
        this.vertexTangents = source.vertexTangents;
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.useClearCoat = source.useClearCoat;
        // this.uniforms = this.cloneUniforms(source.uniforms);

        this.defines = Object.assign({}, source.defines);

        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;

        this.lights = source.lights;
        this.clipping = source.clipping;

        this.skinning = source.skinning;
        this.anisotropy=source.anisotropy;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.uOpacityAdditive = source.uOpacityAdditive;
        this.diffuse = source.diffuse;
        this.extensions = source.extensions;
        this.mapTransform = source.mapTransform;
        this.alphaMapTransform = source.alphaMapTransform;
        this.translucencyMapTransform = source.translucencyMapTransform;
        this.emissiveMapTransform = source.emissiveMapTransform;
        this.roughnessMapTransform = source.roughnessMapTransform;
        this.metalnessMapTransform = source.metalnessMapTransform;
        this.aoMapTransform = source.aoMapTransform;
        this.aoMapIntensity=source.aoMapIntensity;
        this.normalMapTransform = source.normalMapTransform;
        this.bumpMapTransform = source.bumpMapTransform;
        this.lightMapTransform = source.lightMapTransform;
        this.uSubsurfaceTranslucencyThicknessFactor = source.uSubsurfaceTranslucencyThicknessFactor;
        this.uSubsurfaceTranslucencyFactor = source.uSubsurfaceTranslucencyFactor;
        this.uSubsurfaceTranslucencyColor = source.uSubsurfaceTranslucencyColor;
        this.uClearCoatFactor = source.uClearCoatFactor;
        this.uEmitMultiplicative = source.uEmitMultiplicative;
        this.uClearCoatRoughnessFactor = source.uClearCoatRoughnessFactor;
        this.uClearCoatIor = source.uClearCoatIor;
        this.uClearCoatTint = source.uClearCoatTint;
        this.uClearCoatThickness = source.uClearCoatThickness;
        this.normalScale = source.normalScale;
        this.bumpScale = source.bumpScale;
        this.uEnvironmentTransform = source.uEnvironmentTransform;
        this.emissiveIntensity = source.emissiveIntensity;
        this.uSpecularF0Factor = source.uSpecularF0Factor;
        this.uClearCoatF0 = source.uClearCoatF0;
        this.uSpecularPeak = source.uSpecularPeak;
        this.uTextureEnvironmentSpecularPBRLodRange = source.uTextureEnvironmentSpecularPBRLodRange;
        this.uTextureEnvironmentSpecularPBRTextureSize = source.uTextureEnvironmentSpecularPBRTextureSize;
        this.uDiffuseSPH = source.uDiffuseSPH;
        this.sIntegrateBRDF = source.sIntegrateBRDF;
        this.uDiffuseSPH = source.uDiffuseSPH;
        this.uMultiplyLightMap = source.uMultiplyLightMap;
        this.emissive = source.emissive;
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.uEnvironmentExposure = source.uEnvironmentExposure;
        this.envMapIntensity = source.envMapIntensity;
        this.uHalton = source.uHalton;
        this.opacity = source.opacity;
        this.uDrawOpaque = source.uDrawOpaque;
        this.uAOPBROccludeSpecular = source.uAOPBROccludeSpecular;
        this.map_uv = source.map_uv;
        this.alphaMap_uv = source.alphaMap_uv;
        this.emissiveMap_uv = source.emissiveMap_uv;
        this.roughnessMap_uv = source.roughnessMap_uv;
        this.roughnessMap_uv = source.roughnessMap_uv;
        this.metalnessMap_uv = source.metalnessMap_uv;
        this.aoMap_uv = source.aoMap_uv;
        this.normalMap_uv = source.normalMap_uv;
        this.bumpMap_uv = source.bumpMap_uv;
        this.lightMap_uv = source.lightMap_uv;
        this.uNormalMapFlipY = source.uNormalMapFlipY;
        this.uNormalMapFactor = source.uNormalMapFactor;

        this.uAnisotropyDirection=source.uAnisotropyDirection;
        this.uAnisotropyFactor=source.uAnisotropyFactor;

        this.map = source.map;
        this.envmap = source.envmap;
        this.alphaMap = source.alphaMap;
        this.aoMap = source.aoMap;
        this.emissiveMap = source.emissiveMap;
        this.lightMap = source.lightMap;
        this.roughnessMap = source.roughnessMap;
        this.normalMap = source.normalMap;
        this.bumpMap = source.bumpMap;
        this.metalnessMap = source.metalnessMap;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.useSSS = source.useSSS;
        this.useClearCoat = source.useClearCoat;
        this.uniforms = source.uniforms;
        this.needsUpdate = true;
        this.lightMapIntensity = source.lightMapIntensity;
        this.side=source.side;
        this.transparent=source.transparent;
        return this;

    }
    //复制参数
    copy(source) {
        Material.prototype.copy.call(this, source);
        this.isPBRShaderMaterial = true;
        this.materialType = "PBRShaderMaterial";
        this.vertexTangents = source.vertexTangents;
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.useClearCoat = source.useClearCoat;
        this.anisotropy=source.anisotropy;

        // this.uniforms = this.cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);

        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;

        this.lights = source.lights;
        this.clipping = source.clipping;

        this.skinning = source.skinning;

        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.uOpacityAdditive = source.uOpacityAdditive;
        if (source.diffuse.isColor) {
            this.diffuse.copy(source.diffuse);
        } else if (Array.isArray(source.diffuse)) {
            this.diffuse.fromArray(source.diffuse)
        }

        this.extensions = source.extensions;
        this.mapTransform.copy(source.mapTransform);
        this.alphaMapTransform.copy(source.alphaMapTransform);
        this.translucencyMapTransform.copy(source.translucencyMapTransform);
        this.emissiveMapTransform.copy(source.emissiveMapTransform);
        this.roughnessMapTransform.copy(source.roughnessMapTransform);
        this.metalnessMapTransform.copy(source.metalnessMapTransform);
        this.aoMapTransform.copy(source.aoMapTransform);
        this.normalMapTransform.copy(source.normalMapTransform);
        this.bumpMapTransform.copy(source.bumpMapTransform);
        this.lightMapTransform.copy(source.lightMapTransform);
        this.uAnisotropyDirection = source.uAnisotropyDirection;
        this.uAnisotropyFactor = source.uAnisotropyFactor;
        this.uSubsurfaceTranslucencyThicknessFactor = source.uSubsurfaceTranslucencyThicknessFactor;
        this.uSubsurfaceTranslucencyFactor = source.uSubsurfaceTranslucencyFactor;
        this.uSubsurfaceTranslucencyColor.copy(source.uSubsurfaceTranslucencyColor);
        this.uClearCoatFactor = source.uClearCoatFactor;
        this.uEmitMultiplicative = source.uEmitMultiplicative;
        this.uClearCoatRoughnessFactor = source.uClearCoatRoughnessFactor;
        this.uClearCoatIor = source.uClearCoatIor;
        this.uClearCoatTint.copy(source.uClearCoatTint);
        this.uClearCoatThickness = source.uClearCoatThickness;
        this.bumpScale = source.bumpScale;
        this.uEnvironmentTransform.copy(source.uEnvironmentTransform);
        this.normalScale.copy(source.normalScale);
        this.emissiveIntensity = source.emissiveIntensity;
        this.uSpecularF0Factor = source.uSpecularF0Factor;
        this.uClearCoatF0 = source.uClearCoatF0;
        this.uSpecularPeak = source.uSpecularPeak;
        this.uMultiplyLightMap = source.uMultiplyLightMap;
        this.emissive.copy(source.emissive);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.lightMapIntensity = source.lightMapIntensity;
        this.uEnvironmentExposure = source.uEnvironmentExposure;
        this.envMapIntensity = source.envMapIntensity;
        this.uHalton.copy(source.uHalton);
        this.opacity = source.opacity;
        this.uDrawOpaque = source.uDrawOpaque;
        this.uAOPBROccludeSpecular = source.uAOPBROccludeSpecular;
        this.map_uv = source.map_uv;
        this.alphaMap_uv = source.alphaMap_uv;
        this.emissiveMap_uv = source.emissiveMap_uv;
        this.roughnessMap_uv = source.roughnessMap_uv;
        this.roughnessMap_uv = source.roughnessMap_uv;
        this.metalnessMap_uv = source.metalnessMap_uv;
        this.aoMap_uv = source.aoMap_uv;
        this.aoMapIntensity= source.aoMapIntensity;
        this.normalMap_uv = source.normalMap_uv;
        this.bumpMap_uv = source.bumpMap_uv;
        this.lightMap_uv = source.lightMap_uv;
        this.uNormalMapFlipY = source.uNormalMapFlipY;
        this.uNormalMapFactor = source.uNormalMapFactor;
        this.map = source.map;
        this.envmap = source.envmap;
        this.alphaMap = source.alphaMap;
        this.aoMap = source.aoMap;
        this.emissiveMap = source.emissiveMap;
        this.lightMap = source.lightMap;
        this.roughnessMap = source.roughnessMap;
        this.normalMap = source.normalMap;
        this.bumpMap = source.bumpMap;
        this.metalnessMap = source.metalnessMap;
        this.translucencyMap = source.translucencyMap;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.useSSS = source.useSSS;
        this.useClearCoat = source.useClearCoat;
        this.needsUpdate = true;
        this.side=source.side;
        this.transparent=source.transparent;
        return this;

    }
    setTexture(mapName, texture) {

        if (this.uniforms[mapName]) {
            this[mapName] = texture;
            texture.needsUpdate = true;
            this.setTextureUv(mapName, texture.texCoord)

        }
        this.needsUpdate = true;

    }
    setUniformValue(name, value) {
        this[name] = value;
        if (this.uniforms[name]) {
            this.uniforms[name].value = value;
        }

    }
    getUniforms(name) {
        if (this.uniforms[name]) {
            return this.uniforms[name].value;
        } else {
            console.error(this.name + "  unifroms  " + name + "  不存在  ")
        }

    }
    setTextureUv(texturType, uvType) {
        if (uvType === undefined) {
            return;
        }
        switch (texturType) {
            case "map":
                this.uniforms.map_uv.value = uvType;
                break;
            case "alphaMap":
                this.uniforms.alphaMap_uv.value = uvType;
                break;
            case "emissiveMap":
                this.uniforms.emissiveMap_uv.value = uvType;
                break;
            case "roughnessMap":
                this.uniforms.roughnessMap_uv.value = uvType;
                break;
            case "metalnessMap":
                this.uniforms.metalnessMap_uv.value = uvType;
                break;
            case "aoMap":
                this.uniforms.aoMap_uv.value = uvType;
                break;
            case "normalMap":
                this.uniforms.normalMap_uv.value = uvType;
                break;
            case "bumpMap":
                this.uniforms.bumpMap_uv.value = uvType;
                break;
            case "lightMap":
                this.uniforms.lightMap_uv.value = uvType;
                break;

        }

    }
}
export default PBRShaderMaterial;